const translations = {
  'project.title': 'Projects',
  'project.edit': 'Editing project',
  'project.new': 'New project',
  'project.create': 'Creating project',
  'project.cloning': 'Cloning project',
  'project.cloning.subtitle': 'This action will create a new project with the same data as the project',
  'project.remove.confirmation': 'Are you sure you want to remove?',
  'project.remove.success': 'Project removed successfully!',
  'project.remove.error': 'An error occurred while removing!',
  'project.form.field.name': 'Name',
  'project.form.field.color': 'Color',
  'project.form.field.icon': 'Icon',
  'project.list.item.action.edit': 'Edit',
  'project.list.item.action.remove': 'Remove',
  'project.list.item.new.project': 'New project',
  'project.templates.createNew': 'Create new',
  'project.templates.newProjectDescription': 'New project.',
  'project.templates.new': 'New',
  'project.templates.templates': 'Templates',
  'project.templates.selectTemplate': 'Select a template'
}

export default translations
